import api from './api';

// Talks to /api/revenue-posting/* — where gross revenue and discounts land in
// the ledger. Two catalogues, one service, because the page edits them together.
//
// Version comes from the x-budget-version-id header. NOT site-scoped on read: a
// rule can be scoped to a site, but a national account belongs to no depot.
export const revenuePostingService = {
  // { revenue, discount, picks, coverage }
  //
  // `coverage` is the revenue and discount value that currently posts NOWHERE.
  // Shown on the page before any rule is, because unposted revenue does not
  // error — the P&L simply loses the credit and the budget looks catastrophic
  // rather than incomplete.
  getPosting: async () => {
    const res = await api.get('/revenue-posting');
    return res.data;
  },

  // kind: 'revenue' | 'discount'. Upsert by scope.
  savePosting: async (kind, rules) => {
    const res = await api.put(`/revenue-posting/${kind}`, { rules });
    return res.data;
  },

  deletePosting: async (kind, postingId) => {
    const res = await api.delete(`/revenue-posting/${kind}/${encodeURIComponent(postingId)}`);
    return res.data;
  },
};

export default revenuePostingService;
